"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeId = void 0;
var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
function rndChar(characters, offset) {
    if (offset === void 0) { offset = 0; }
    return characters.charAt(Math.floor(Math.random() * (characters.length - offset)));
}
/**
 * Returns a pseudo randomly generated id.
 * Note: to generate random string that are valid IDs
 * the first char is guaranteed to be a string.
 * @param length The length of the id
 */
function makeId(length) {
    if (length === void 0) { length = 5; }
    var result = rndChar(characters, 10);
    for (var i = 1; i < length; i++) {
        result += rndChar(characters);
    }
    return result;
}
exports.makeId = makeId;
exports.default = makeId;
//# sourceMappingURL=make-id.js.map